import React from 'react';

import {
  BulkImportUsersInput,
  useBulkImportUsersMutation,
  useUploadUsersModalQuery,
  useValidateEmailsAvailableLazyQuery
} from 'generated/graphql';
import _ from 'lodash';
import { useLoading } from 'modules';


export function useQuery() {
  const tuple = useUploadUsersModalQuery({});
  const [bulkImportUsers, bulkImportUsersTuple] = __useBulkImportUsersMutation();
  const [validateEmailsAvailable, validateEmailsAvailableTuple] = __useValidateEmailsAvailable();
  const loading = useLoading([tuple, bulkImportUsersTuple, validateEmailsAvailableTuple]);


  const data = React.useMemo(() => ({
    investmentAreaDisplayName2Id: _.keyBy(tuple.data?.investmentAreas, area => area.displayName)
  }), [tuple.data]);



  return {
    ...tuple,
    loading,
    data,
    queries: {
      validateEmailsAvailable
    },
    mutations: {
      bulkImportUsers
    }
  };
}



function __useBulkImportUsersMutation() {
  const [fnMutate, tuple] = useBulkImportUsersMutation();

  async function fnWrappedMutate(input: BulkImportUsersInput) {
    await fnMutate({ variables: { input } });
  }

  return [
    fnWrappedMutate,
    {
      ...tuple,
      data: null
    }
  ] as const;
}




function __useValidateEmailsAvailable() {
  const [fnQuery, tuple] = useValidateEmailsAvailableLazyQuery({
    fetchPolicy: 'network-only'
  });

  async function fnWrappedQuery(emails: string[]) {
    const result = await fnQuery({ variables: { emails } });

    return _.filter(result.data?.validateEmailsAvailable ?? []);
  }

  return [fnWrappedQuery, tuple] as const;
}
